import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=14455f03&"
import script from "./add-user.ts?vue&type=script&lang=ts&"
export * from "./add-user.ts?vue&type=script&lang=ts&"
import style0 from "./add-user.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports